/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lineInfo: NonNullable<unknown>, totalChars: NonNullable<unknown> }} Event_Metrics_Chars_TitleInputs */



/**
* | output |
* | --- |
* | "{lineInfo} = {totalChars} Total Characters" |
*
* @param {Event_Metrics_Chars_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_chars_title = /** @type {((inputs: Event_Metrics_Chars_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Chars_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Caracteres totaux`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Gesamtzeichen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Caratteri totali`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Всего символов`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Caracteres totales`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} 总字符数`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} 合計文字数`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} कुल अक्षर`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Total de caracteres`)
	return /** @type {LocalizedString} */ (`${i?.lineInfo} = ${i?.totalChars} Total Characters`)
});